import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

interface Props {
  additionalClasses?: string;
  animationName?: string;
  width?: number;
  height?: number;
  loop?: boolean;
  autoplay?: boolean;
}

const LottieIcon: React.FC<Props> = props => {
  const { additionalClasses, animationName, width, height, loop, autoplay } = props;
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    if (animationName) {
      import(`../../../public/animations/${animationName}.json`)
        .then(data => setAnimationData(data))
        .catch(err => console.error(`Failed to load animation: ${animationName}`, err));
    }
  }, [animationName]);

  // Create a placeholder with the same dimensions
  return (
    <div style={{ width, height, display: 'inline-block' }} className={additionalClasses}>
      {animationData && (
        <Lottie
          animationData={animationData}
          loop={loop}
          autoplay={autoplay}
          style={{ width: '100%', height: '100%' }}
        />
      )}
    </div>
  );
};

export default LottieIcon;
